var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import StepBadgeLargeUrl from '@svgs/global/StepBadgeLarge.svg?url';
import StepBadgeSmallUrl from '@svgs/global/StepBadgeSmall.svg?url';
import { clsx } from 'clsx';
function StepBadge(_a) {
    var step = _a.step, _b = _a.size, size = _b === void 0 ? 'large' : _b;
    var sizeStyle = size === 'small' ? 'w-[62px] h-[62px]' : 'w-[91px] h-[91px]';
    var fontSizeStyle = size === 'small' ? 'text-2xs-head-m' : 'text-xs-head-m';
    return (_jsx("div", __assign({ style: {
            backgroundImage: "url(".concat(size === 'small' ? StepBadgeSmallUrl : StepBadgeLargeUrl, ")"),
            backgroundSize: 'cover',
        }, className: "".concat(sizeStyle, " flex justify-center items-center") }, { children: _jsxs("p", __assign({ className: clsx('font-display leading-[100%]', fontSizeStyle, 'translate-y-[1px]' // when centered, the text looks a pixel above center due to the letter 'p' in 'Step'
            ) }, { children: ["Step ", step] })) })));
}
export default StepBadge;
